<!-- @format -->

<div
  role="group"
  [attr.aria-labelledby]="selectionUIState !== 'DISABLED' ? ruleLegendId() : undefined"
  [attr.id]="ruleFocusId()"
  [tabindex]="-1">
  @if (selectionUIState !== "DISABLED") {
    @if (creditsRuleWithResult(); as header) {
      <sis-plan-structure-credit-rule-header
        [onlyShowRule]="selectionUIState === 'SELECTABLE'"
        [parentModule]="_parentModule()"
        [ruleDepthLevel]="ruleDepthLevel"
        [ruleValidationResults]="header.result"
        [ruleLegendId]="ruleLegendId()"
        [rule]="header.rule">
      </sis-plan-structure-credit-rule-header>
    } @else if (courseUnitCountRuleWithResult(); as header) {
      <sis-plan-structure-count-rule-header
        [onlyShowRule]="selectionUIState === 'SELECTABLE'"
        [rule]="header.rule"
        [ruleLegendId]="ruleLegendId()"
        [ruleValidationResults]="header.result">
      </sis-plan-structure-count-rule-header>
    }
  }
  @if (ruleErrors && ruleErrors()?.length > 0) {
    <sis-plan-structure-rule-error-list [ruleErrors]="ruleErrors()"> </sis-plan-structure-rule-error-list>
  }
  <sis-plan-structure-select-rule
    [rule]="_rule().rule"
    [headingLevel]="headingLevel"
    [parentModule]="_parentModule()"
    [planStateObject]="_planStateObject()"
    [selectionUIState]="selectionUIState"
    [groupPrefix]="groupPrefix"
    [ruleDepthLevel]="ruleDepthLevel + 1">
  </sis-plan-structure-select-rule>
</div>
